export default __webpack_public_path__ + "static/media/14.b6b66fef.jpg";